export const fromDatetimeLocal = (local: string): string | undefined => {
  if (!local) return undefined;
  const d = new Date(local);
  if (Number.isNaN(d.getTime())) return undefined;
  return d.toISOString();
};
